import { axiosInstance } from "../Context/CreateAxios"
import { GSTList, updateGST, insertGST, archiveGST, } from "../services/Api"
import handleError from "../utils/handleError"

export const GST_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(GSTList(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const INSERT_GST = async (body) => {
    try {
        let response = await axiosInstance.post(insertGST(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const EDIT_GST = async (body) => {
    try {
        let response = await axiosInstance.post(updateGST(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const ARCHIVE_GST = async (body) => {
    try {
        let response = await axiosInstance.post(archiveGST(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}